var _rect, _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 720,
    viewBox: "0 0 720 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    fill: "#0A0A0A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    stroke: "#D4AF37",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 120H720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240H720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 360H720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 480H720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600H720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 0V720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0V720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 0V720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 0V720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0V720"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 180,
    r: 96,
    fill: "url(#paint0_radial_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(540 180) rotate(90) scale(96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4AF37",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4AF37",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandGrid);
export default __webpack_public_path__ + "static/media/brand-grid.d13ba9bedfd508624eda524414a685dc.svg";
export { ForwardRef as ReactComponent };